import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "var(--color-black)",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M8 1.333c.368 0 .667.299.667.667v12a.667.667 0 1 1-1.334 0V2c0-.368.299-.667.667-.667M2.529 4.862c.26-.26.682-.26.942 0l2.667 2.667c.26.26.26.682 0 .942l-2.667 2.667a.667.667 0 0 1-.942-.943l1.528-1.528H1.333a.667.667 0 0 1 0-1.334h2.724L2.53 5.805a.667.667 0 0 1 0-.943m10.942 0c.26.26.26.682 0 .943l-1.528 1.528h2.724a.667.667 0 1 1 0 1.334h-2.724l1.528 1.528a.667.667 0 0 1-.942.943L9.862 8.471a.667.667 0 0 1 0-.942l2.667-2.667c.26-.26.682-.26.942 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }